import { forwardRef } from "react";
import type { ShowcaseCapability } from "../../types.ts";
import { SlideEyebrow, SlideHeading, StatusPill } from "../common.tsx";
import { IconStar } from "../icons.tsx";

interface Props {
  index: number;
  capabilities: ShowcaseCapability[];
}

function CapCard({ cap }: { cap: ShowcaseCapability }) {
  return (
    <div className="dz-marquee" aria-hidden={undefined}>
      <div className="dz-marquee__star"><IconStar /></div>
      <h3>{cap.title}</h3>
      <p>{cap.description}</p>
      <div className="dz-marquee__footer">
        {cap.status && <StatusPill status={cap.status} />}
      </div>
    </div>
  );
}

export const MarqueeSlide = forwardRef<HTMLElement, Props>(function MarqueeSlide(
  { index, capabilities },
  ref
) {
  return (
    <section ref={ref} className="dz-slide dz-slide--marquee">
      {/* Text — inside container, full width, above the track */}
      <div className="dz-container">
        <SlideEyebrow index={index} label="Critical Abilities" />
        <SlideHeading plain="What makes it "><em>different</em>.</SlideHeading>
        <p className="dz-lede">
          The capabilities below are the marquee features that lead the demo, each backed by real code.
        </p>
      </div>

      {/* Scroll track — full viewport width, sits below the text */}
      <div className="dz-marquee-track-wrap">
        <div className="dz-marquee-track">
          {capabilities.map((cap, i) => <CapCard key={`a-${i}`} cap={cap} />)}
          {capabilities.map((cap, i) => <CapCard key={`b-${i}`} cap={cap} />)}
        </div>
      </div>
    </section>
  );
});

